import CompanyRoleUserSettings from "./role-user";
import ServerSettings, {ServerSettingsFieldType} from "../../../gd/settings/server-settings/server-settings";


const fieldsConfig = {

    user : {
        type            : ServerSettingsFieldType.CLASS,
        class           : CompanyRoleUserSettings
    },


}


export default class CompanyRoleSettings extends ServerSettings {


    public user     : CompanyRoleUserSettings

    constructor(config:any) {

        super(config, fieldsConfig);

        this.user       = this.initValue('user')
    }

    toJSON() {

        const result = {};

        this.valueToJson(result, 'user')

        return result;
    }

}